import { CacheKeys } from 'cache-keys-enum';
import { ApiRoute } from 'enums';

import { useQuery } from 'react-query';
import { ArchivalUnitCopy } from 'types';
import fetch from 'utils/fetch';

export const useArchivalUnitDetail = (id?: string, enabled?: boolean) =>
  useQuery(
    [CacheKeys.ARCHIVAL_UNIT, id],
    () =>
      fetch(`/api/${ApiRoute.ARCHIVAL_UNIT}/${id}`).then(
        async (r) => (await r.json()) as ArchivalUnitCopy
      ),
    { enabled: !!id }
  );
